import React, { useContext, useEffect } from "react";
import { withRouter, Redirect } from "react-router-dom";
import { UserContext } from "../providers/userData";

const SignOut = (props) => {
  const { userDispatch } = useContext(UserContext);

  useEffect(() => {
    localStorage.removeItem("biometricEnrolled");
    userDispatch({ type: "SIGNOUT" });
    props.history.push("/signin");
  });

  return <Redirect to="/signin" />;
};

export default withRouter(SignOut);
